import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/core/hooks/useAuth";
import { fetchBillingSummary } from "@/core/api/billingApi";

/**
 * Resumo do plano/assinatura da Company para o bloco "Plano atual" da tela
 * Configurações → Faturamento (SA-1120). Lido do banco (sem Stripe).
 */
export function useBillingSummary(companyId: string | null | undefined) {
  const { token } = useAuth();

  return useQuery({
    queryKey: ["billing", "summary", companyId ?? "__none__"],
    queryFn: () => fetchBillingSummary(token, companyId!),
    enabled: Boolean(companyId),
  });
}
